<template>
  <div class="app">
    <el-dialog
      :title="$t('container.myInfo')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="myInfoVisible"
      width="350px"
      >
    <el-form >
    <el-timeline>
      <el-timeline-item color='#0bbd87' icon='el-icon-user' size="large">
          <span style="color:#909399">{{$t('container.account')}}</span>{{this.userInfoForm.userAccount}}
      </el-timeline-item>
      <el-timeline-item color='#0bbd87' icon='el-icon-user' size="large">
           <span style="color:#909399">{{$t('container.userName')}}</span>{{this.userInfoForm.userName}}
      </el-timeline-item>
      <el-timeline-item color='#0bbd87' icon='el-icon-date' size="large">
           <span style="color:#909399">{{$t('container.registerTime')}}</span>{{this.userInfoForm.registTime}}
      </el-timeline-item>
      <el-timeline-item color='#0bbd87' icon='el-icon-date' size="large">
           <span style="color:#909399">{{$t('container.lastLoginTime')}}</span>{{this.userInfoForm.lastLoginTime}} 
      </el-timeline-item>
    </el-timeline>
    </el-form>
     <!-- <el-form :inline="true"  class="demo-form-inline">
         <el-form-item :label="$t('container.account')" label-width="130px">
            {{this.userInfoForm.userAccount}}
         </el-form-item>
         <el-form-item :label="$t('container.userName')" label-width="130px">
            {{this.userInfoForm.userName}}
         </el-form-item> 
         <el-form-item :label="$t('container.registerTime')" label-width="130px">
            {{this.userInfoForm.registTime}}
         </el-form-item> 
         <el-form-item :label="$t('container.lastLoginTime')" label-width="130px">
            {{this.userInfoForm.lastLoginTime}}
         </el-form-item>   
     </el-form>   -->
    </el-dialog>  
    <el-dialog
      :title="$t('container.updatePassword')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="updatePasswordVisible"
      width="450px"
    >
    <el-form >
      <el-form-item :label="$t('container.oldPassword')">
         <el-input type="password" v-model="updatePassword.oldPassword" style="width:250px" placeholder=""></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('container.newPassword')">
          <el-input type="password" v-model="updatePassword.newPassword" style="width:250px" placeholder=""></el-input>
      </el-form-item>  
     
      <el-form-item :label="$t('container.imageCode')">
        <el-col :span="10">
          <el-input maxlength="4" v-model="updatePassword.imgCode" placeholder=""></el-input>
        </el-col>
         <el-col :span="8">
          <el-image
        
           :src="imageSrc"
           fit="fill"
           @click="changeCode"
          ></el-image>
        </el-col> 
      </el-form-item>
      
          
      <el-form-item style="display:flex;justify-content:center;align-items:center;">
          <el-button type="primary" @click="confirmUpdatePasswrod">{{$t("register.confirm")}}</el-button>
          <el-button type="primary" @click="updatePasswordVisible=false">{{$t("register.cancel")}}</el-button>
      </el-form-item>
    </el-form>  
    </el-dialog>
    <el-container>
      <!-- 左边菜单   -->
      <el-aside style="" class="app-side app-side-left" :class="isCollapse ? 'app-side-collapsed' : 'app-side-expanded'">
        <div class="app-side-logo" style="display: flex;align-items: center;justify-content: center;" @click="home">
            <img src="@/assets/hnlogo.png" :width="isCollapse ? '40' : '40'" height="40"/> 
            <div id="logoTxt" style="margin-left: 2px;display: block;font-size:28px;" v-show="isshow"><font style="color:#fff;cursor: pointer;">Home</font></div>
        </div>
        <div>
          <!-- 我是样例菜单 -->
          <!--default-active="1-4-1"-->
          <!-- 默认打开到那个节点 -->
        <el-menu
            router
            class="el-menu-vertical-demo"
            default-active="/home"
            background-color="#304156"
            text-color="#bfcbd9"
            active-text-color="#409EFF"
            @select="handleOpen"
            :collapse="isCollapse"
            :unique-opened="true"
            style="border:1px solid #304156"
          >
           <!-- <el-submenu index="1">
              <template slot="title">
                <i class="el-icon-setting"></i>
                <span slot="title">设备管理</span>
              </template>
              <el-menu-item index="/gatewayList" class="el-icon-setting">网关管理</el-menu-item>
              <el-menu-item index="/lockList" class="el-icon-setting">门锁管理</el-menu-item>
            </el-submenu> -->

            <el-menu-item index="/deviceList">
             <div :v-intro="$t('container.mask-password')" data-highlightClass=helperLayer data-position=top data-disable-interaction=false v-intro-step="1">
              <i class="el-icon-menu"></i>
              <span slot="title">{{$t('container.deviceManage')}}</span>
               </div>
            </el-menu-item>

            <el-menu-item index="/fingerprintList">
             <div :v-intro="$t('container.mask-password')" data-position=left data-disable-interaction=false v-intro-step="2">
              <i class="el-icon-thumb"></i>
              <span slot="title">{{$t('container.fingerprintManage')}}</span>
               </div>
            </el-menu-item>

            <!-- <el-menu-item index="/roomList">
             <div :v-intro="$t('container.mask-password')" data-position=left data-disable-interaction=false v-intro-step="3">
              <i class="el-icon-house"></i>
              <span slot="title">{{$t('container.roomManage')}}</span>
               </div>
            </el-menu-item> -->

            <!-- <el-menu-item index="/deviceApartmentTabs">
             <div :v-intro="$t('container.mask-password')" data-position=left data-disable-interaction=false v-intro-step="3">
              <i class="el-icon-menu"></i>
              <span slot="title">{{$t('container.roomManage')}}</span>
               </div>
            </el-menu-item> -->
          
            <el-menu-item index="/apartmentTabs">
             <div :v-intro="$t('container.mask-apartment')" data-position='left' data-disable-interaction=false v-intro-step="4">
              <i class="el-icon-office-building"></i>
              <span slot="title">{{$t('container.apartmentManage')}}</span>
             </div>
            </el-menu-item>

            <el-submenu index="5">
              <template slot="title">
                <i class="el-icon-house"></i>
                <span slot="title">{{$t('container.roomManage')}}</span>
              </template>
              <el-menu-item index="/roomList" class="el-icon-house">{{$t('tenantDetail.roomList')}}</el-menu-item>
              <!-- <el-menu-item index="/buildingList" class="el-icon-office-building">楼栋列表</el-menu-item> -->
            </el-submenu>
           
            <el-menu-item index="/tenantList">
              <div :v-intro="$t('container.mask-tenant')" data-position='left' data-disable-interaction=false v-intro-step="5">
              <i class="el-icon-s-custom"></i>
              <span slot="title" >{{$t('container.tenantManage')}}</span>
              </div>
            </el-menu-item>

            <el-submenu index="6">
              <template slot="title">
                <i class="el-icon-share"></i>
                <span slot="title">{{$t('container.butlerManage')}}</span>
              </template>
              <el-menu-item index="/roleList" class="el-icon-s-operation">{{$t('container.role')}}</el-menu-item>
              <el-menu-item index="/butlerList" class="el-icon-user">{{$t('container.bulter')}}</el-menu-item>
              <el-menu-item index="/groupList" class="el-icon-s-grid">{{$t('groupList.group')}}</el-menu-item>
            </el-submenu>
           
            <!-- <el-menu-item index="/worksheetList">
              <i class="el-icon-setting"></i>
              <span slot="title" >工单管理</span>
            </el-menu-item> -->

            <!-- <el-submenu index="3">
              <template slot="title">
                <i class="el-icon-setting"></i>
                <span slot="title">报表</span>
              </template>
              <el-menu-item index="/roomStatistics" class="el-icon-setting">房源统计</el-menu-item>
            </el-submenu> -->

            <!-- <el-menu-item index="/systemRecord">
              <i class="el-icon-document"></i>
              <span slot="title">{{$t('container.operateRecode')}}</span>
            </el-menu-item> -->

             <el-submenu index="7">
              <template slot="title">
                <i class="el-icon-folder-opened"></i>
                <span slot="title">{{$t('container.record')}}</span>
              </template>
             
              <el-menu-item index="/alarmRecord" class="el-icon-data-line">{{$t('container.alarmRecord')}}</el-menu-item>
              <el-menu-item index="/openRecord" class="el-icon-user">{{$t('container.openRecord')}}</el-menu-item>
              <el-menu-item index="/systemRecord" class="el-icon-setting">{{$t('container.systemRecord')}}</el-menu-item>
               <el-menu-item index="/analysisOpenRecord" class="el-icon-setting">{{$t('container.openRecordAnalyse')}}</el-menu-item>
            </el-submenu>

        </el-menu>

        </div>
      </el-aside>

      <!-- 右边 -->
      <el-container>
        <!-- 右边头部   -->
        <el-header class="app-header">
          <div style="width: 40px; cursor: pointer;" @click.prevent="toggleSideBar">
            <i v-show="!isCollapse" class="el-icon-d-arrow-left"></i>
            <i v-show="isCollapse" class="el-icon-d-arrow-right"></i>
          </div>
          <el-breadcrumb class="breadcrumb-container" separator-class="el-icon-arrow-right">
            <el-breadcrumb-item v-for="item in levelList" :key="item.path" :to="item.path"><font style="color:white">{{$t(item.meta.title)}}</font></el-breadcrumb-item>
        </el-breadcrumb>
         <!-- <el-breadcrumb separator-class="el-icon-arrow-right" >
           <el-breadcrumb-item :to="{ path: '/container' }"><font style="color:#fff;cursor: pointer;">首页</font></el-breadcrumb-item>
         </el-breadcrumb> -->
          <!-- <div class="app-header-skin" @click="skin" style="cursor: pointer">
            <i class="el-icon-user"></i>
            <span slot="title">换肤</span>
            <el-dialog
              title="换肤"
              :visible.sync="dialogTableVisible"
              center
              :append-to-body="true"
              :lock-scroll="false"
              width="30%"
            >
              <themePicker></themePicker>
            </el-dialog>
          </div> -->
          <div class="app-header-userinfo">
            <i class="el-icon-user"></i>
            <el-dropdown trigger="hover" :hide-on-click="false" style="margin-left:2px">
              <span class="el-dropdown-link" style="color:white">
                {{ username }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="myInfoVisible=true">{{$t('container.myInfo')}}</el-dropdown-item>
                <el-dropdown-item @click.native="updatePasswordVisible=true">{{$t('container.updatePassword')}}</el-dropdown-item>
                <!-- <el-dropdown-item>系统设置</el-dropdown-item> -->
                <el-dropdown-item divided @click.native="logout">{{$t('container.checkOut')}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>

        <!-- 右边中间模块 -->
        <el-main class="app-body">
          <template>
            <router-view />
          </template>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>


<script>
import themePicker from "./themePicker.vue";
import Breadcrumb from './navbar.vue'

export default {
  name: "Container",
  data() {
    return {
      imageSrc:null,
      imageCodeId:"",
      updatePasswordVisible:false,
      levelList: [],
      userInfo:null,
      userData:null,
      username: "",
      isCollapse: false,
      isshow: true,
      dialogTableVisible: false,
      myInfoVisible:false,
      userInfoForm:{
        userAccount:"",
        userName:"",
        registTime:null,
        lastLoginTime:null
      },
      updatePassword:{
        newPassword:"",
        oldPassword:"",
        imgCode:"",
      }
    };
  },
  components: {
      themePicker,
      Breadcrumb
  },
  methods: {
    //提交修改密码
    confirmUpdatePasswrod(){
      var newPassword=this.updatePassword.newPassword;
      var oldPassword=this.updatePassword.oldPassword;
      if(newPassword==""||newPassword==null){
        this.$message({
          message: "新密码不能为空",
          type: "warning"
        });
        return false;
      }
       if(oldPassword==""||oldPassword==null){
        this.$message({
          message: "旧密码不能为空",
          type: "warning"
        });
        return false;
      }
      var formData = new FormData();
      formData.append("newPassword",this.$md5(newPassword+"2FB9680E").toLowerCase());
      formData.append("oldPassword",this.$md5(oldPassword+"2FB9680E").toLowerCase());
      formData.append("picValidCode",this.updatePassword.imgCode);
      formData.append("picValidCodeId",this.imageCodeId);
      formData.append("userId",this.userData.userId);
      
      this.$server.exam("/customer/security/changePassword", formData).then(data => {
        if(data.code == 200) {
          this.updatePasswordVisible=false;
          this.$message({
            message: data.message,
            type: "success"
          });
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },
    //图片码改变事件
    changeCode(){
      this.getValidCode();
    },
    getValidCode() {
      var formData = new FormData();
      this.$server.exam("/customer/security/getPicValidCode", formData).then(data => {
        if (data.code == 200) {
          if (data["code"] == 200) {
            var res = data.data;
            // alert(window.JSON.stringify(res));
            var imageBase64 = res.imageBase64;
            this.imageCodeId = res.codeId;
            this.imageSrc=imageBase64;
          } else {
            this.$message({
             message: data.message,
             type: "warning"
            });
          }
        } else {
          this.logining = false;
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },
    //动态标题，未完善
    getBreadcrumb(path) {
      let matched = this.$route.matched.filter(item => item.name)
      const first = matched[0];
      if (first && first.name.trim().toLocaleLowerCase() !== this.$t('container.home')&& first.name.trim().toLocaleLowerCase() !== 'Home') {
          if(first.name.trim()==this.$t('container.buildingDetail')){
            matched = [{path: '', meta: { title: first.name }}].concat(matched);  
            matched = [{path: '/buildingList', meta: {title:this.$t('container.buildingManage')}}].concat(matched);  
          }
          else if(first.name.trim()==this.$t('container.batchCheckInRoom')){
            matched = [{path: '', meta: { title: first.name }}].concat(matched);  
            matched = [{path: '/roomList', meta: { title:this.$t('container.roomManage')}}].concat(matched);  
          }
          else if(first.name.trim()==this.$t('container.roomDetail')){
            matched = [{path: '', meta: { title: first.name }}].concat(matched);  
            matched = [{path: '/roomList', meta: { title:this.$t('container.roomManage')}}].concat(matched);  
          }
          else if(first.name.trim()==this.$t('container.staffCheckIn')){
            matched = [{path: '', meta: { title: first.name }}].concat(matched);  
            matched = [{path: '/staffList', meta: { title:this.$t('container.staffManage')}}].concat(matched);  
          }
          else if(first.name.trim()==this.$t('container.studentDetail')){
            matched = [{path: '', meta: { title: first.name }}].concat(matched);  
            matched = [{path: '/studentList', meta: { title:this.$t('container.studentManage')}}].concat(matched);  
          }
          else if(first.name.trim()==this.$t('container.staffCheckOut')){
            matched = [{path: '', meta: { title: first.name }}].concat(matched);  
            matched = [{path: '/staffList', meta: { title:this.$t('container.staffManage')}}].concat(matched);  
          }
           else if(first.name.trim()==this.$t('deviceDetail.lockAuth')){
            matched = [{path: '', meta: { title: first.name }}].concat(matched);  
            matched = [{path: '/deviceList', meta: { title:this.$t('deviceDetail.deviceManage')}}].concat(matched);  
          }
          else{
            matched = [{path: '', meta: { title: first.name }}].concat(matched);  
          }
         
      }else{
          matched = [{path: '', meta: { title: first.name}}].concat(matched);
      }
      this.levelList = matched
    },
    getUserDetail(){
        var formData = new FormData();
        this.$server.exam("/customer/security/getUserDetail", formData).then(data => {
            if (data.code == 200) {
               this.userInfo=data.data;
               this.userInfoForm.userAccount=this.userInfo.userAccount;
               this.userInfoForm.userName=this.userInfo.userName;
               this.userInfoForm.registTime= this.$util.formartDateTime(this.userInfo.registTime);
               this.userInfoForm.lastLoginTime=this.$util.formartDateTime(this.userInfo.lastLoginTime);
               this.showGuide();
            } else {
              this.$message({
                message: data.message,
                type: "warning"
              });
            }
        });
    },
    checkLogin(){
        this.$server.exam("/customer/security/checkLogin", {}).then(data => {
            if (data.code == 200) {
                var userData=data.data;
                this.userData=userData;
                this.username=userData.userName;
            } else {
              this.$message({
                message: data.message,
                type: "warning"
              });
            }
        });
    },
    toggleSideBar() {
      this.isshow = !this.isshow;
      this.isCollapse = !this.isCollapse;
    },
    logout: function() {
      this.$confirm(this.$t("container.checkOutConfirm"), this.$t("container.hint"), {
          confirmButtonText: this.$t("container.confirm"),
          cancelButtonText: this.$t("container.cancel"),
          type: 'warning'
      })
        .then(() => {
          var formData = new FormData();
          formData.append("loginClient",0);
          this.$server.exam("/customer/security/logout", formData).then(data => {
            if (data.code == 200) {
               sessionStorage.removeItem("user");
               this.$router.push("/");
            } else {
              this.$message({
                message: data.message,
                type: "warning"
              });
              sessionStorage.removeItem("user");
              this.$router.push("/");
            }
           
          });
          
        })
        .catch(() => {});
    },
    skin: function() {
      this.dialogTableVisible=true;//默认页面不显示为false,点击按钮将这个属性变成true
    },
    home:function(){
        this.$router.push({ path: "/home" }); //默认打开首页  
        // this.getBreadcrumb("/home");
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
      // this.getBreadcrumb(keyPath)
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    showGuide(){
     if(this.userInfoForm.registTime==this.userInfoForm.lastLoginTime){
       var introJS=require("intro.js");
       introJS().setOptions({
        prevLabel: this.$t("container.back"),
        nextLabel: this.$t("container.next"),
        skipLabel: this.$t("container.pass"),
        doneLabel: this.$t("container.finish"),
        hidePrev: true,       // 在第一步中是否隐藏上一个按钮
        hideNext: true,       // 在最后一步中是否隐藏下一个按钮
        exitOnOverlayClick: true,  // 点击叠加层时是否退出介绍
        showStepNumbers: false,     // 是否显示红色圆圈的步骤编号
        disableInteraction: true,   // 是否禁用与突出显示的框内的元素的交互，就是禁止点击
        showBullets: false          // 是否显示面板指示点
      // steps:data
      }).oncomplete(()=> {
      //点击结束按钮后执行的事件
      }).onexit(()=> {
      //点击跳过按钮后执行的事件
      }).start()
     }
    }
  },
  watch: {
    $route(key) {
      this.getBreadcrumb(key.path)
    }
  },
  created() {
    // this.$i18n.locale=localStorage.getItem("language")==""||localStorage.getItem("language")==undefined?'zh':localStorage.getItem("language")
    // this.addCookie("lang", this.$i18n.locale);
    this.getBreadcrumb('/home');
  },  
  mounted: function() {
    this.checkLogin();
    this. getUserDetail();
    this.getValidCode();
    // let user = sessionStorage.getItem("user");
    // if (user) {
    //   this.username = user;
    // }
   // this.$router.push({ path: "/home" }); //默认打开首页
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/container.vue